"use strict";var r=require("react");const e=r.forwardRef,o=r.forwardRef,t=r.forwardRef;exports.polymorphicForwardRef=e,exports.staticForwardDefinedRef=t,exports.staticForwardRef=o;
